<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <tanitimMail ref="tanitimdialog" :servisTipi="1"></tanitimMail>
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t("Hotel-Sales") }} </v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 pt-3 pb-4 pl-2 sm12 md12>
          <v-form ref="OtelFiyatGetir" v-model="validform" lazy-validation>
            <v-card flat>
              <v-layout row wrap="">
                <v-flex pl-1 xs12 sm12 md3>
                  <v-autocomplete
                    @change="aramakontrol()"
                    clearable
                    v-model="SearchInput.LocationKey"
                    :items="oteladitems"
                    :label="$t('Type-Hotel-Province-District')"
                    item-text="name"
                    item-value="value"
                    append-icon="search"
                    hide-details
                    :rules="[(v) => !!v || $t('Mandatory-section')]"
                    :search-input.sync="search"
                  >
                    <template slot="item" slot-scope="data">
                      <v-icon v-if="data.item.deger == 2">apartment</v-icon>
                      <v-icon v-else-if="data.item.deger == 1"
                        >location_on</v-icon
                      >
                      <v-icon v-else-if="data.item.deger == 0">language</v-icon>
                      {{ data.item.name }}
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 md2>
                  <tarihim
                    :etiket="$t('Starting-Date')"
                    :detaygizle="false"
                    v-model="SearchInput.StartDate"
                    :rules="[(v) => !!v || $t('Mandatory-section')]"
                    v-bind:defaultvalue="'ok'"
                  ></tarihim>
                </v-flex>

                <v-flex xs12 sm4 md2>
                  <tarihim
                    :etiket="$t('Finishing-Date')"
                    :detaygizle="false"
                    :rules="[(v) => !!v || $t('Mandatory-section')]"
                    v-bind:defaultvalue="'ok'"
                    v-model="SearchInput.EndDate"
                  ></tarihim>
                </v-flex>

                <v-flex xs9 sm2 md2>
                  <v-menu bottom :close-on-content-click="false" offset-y>
                    <v-btn outline block large flat slot="activator">
                      <v-icon color="info">supervisor_account</v-icon> &nbsp;
                      <span>
                        {{ $t("Number-of-Guests") }} ({{
                          yetiskinSayi
                        }}
                        Yet.)</span
                      >
                    </v-btn>
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-btn
                            outline
                            fab
                            small
                            @click="yetiskinAzalt"
                            :disabled="!!Azalt"
                            color="primary"
                          >
                            <v-icon>remove</v-icon>
                          </v-btn>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title
                            >{{ yetiskinSayi }} {{ $t("Adult") }}
                          </v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <v-btn
                            outline
                            fab
                            small
                            @click="yetiskinArttir"
                            color="primary"
                          >
                            <v-icon>add_box</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>

                      <v-list-tile>
                        <v-list-tile-action>
                          <v-btn
                            @click="cocukAz"
                            :disabled="!!cocukAzalt || !isOnboarding"
                            outline
                            fab
                            small
                            color="primary"
                          >
                            <v-icon>remove</v-icon>
                          </v-btn>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{ cocukSayi }} {{ $t("Child") }}</v-list-tile-title
                          >
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <v-btn
                            @click="cocukArttir"
                            :disabled="!isOnboarding"
                            outline
                            fab
                            small
                            color="primary"
                          >
                            <v-icon>add_box</v-icon>
                          </v-btn>
                        </v-list-tile-action>

          
                      </v-list-tile>

                      <v-list two-line>
                          <template v-for="index in cocukSayi">
                            <v-list-tile :key="'obj'+index">
                              <v-list-tile-content>
                                <v-list-tile-title> </v-list-tile-title>
                                <v-list-tile-sub-title>
                                  <v-select
                                    @change="getReadyChildAgeList($event,index)"
                                    :items="cocukSayiItems"
                                    :label="index + '. Çocuk yaşı'"
                                  ></v-select>
                                </v-list-tile-sub-title>
                              </v-list-tile-content>

                            </v-list-tile>
                            <v-divider :key="index"></v-divider>
                          </template>
                      </v-list>
                   
                    </v-list>
                       
                

                  </v-menu>
                </v-flex>

                <v-flex xs12 sm4 md1>
                  <v-select
                    :label="$t('Markup-Type')"
                    v-model="SearchInput.MarkupType"
                    :items="markupitems"
                    item-text="text"
                    item-value="value"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4 md1>
                  <parainput
                    v-if="SearchInput.MarkupType == 0"
                    v-model="SearchInput.MarkupPrice"
                    :simge="getparabirimi()"
                    :etiket="$t('Markup-Amount')"
                    :autocomplete="'autocomplete'"
                  ></parainput>

                  <yuzdeinput
                    v-if="SearchInput.MarkupType == 1"
                    :etiket="$t('Markup-Percentage')"
                    v-model="SearchInput.MarkupPrice"
                  >
                  </yuzdeinput>
                </v-flex>

          

                <v-flex xs2 sm2 pr-2 md1>
                  <v-btn
                    color="info"
                    block
                    large
                    v-if="demoKayit"
                    outline
                    @click="checkSearch()"
                  >
                    <v-icon>search</v-icon>&nbsp;Otel Ara
                  </v-btn>
                  <v-btn
                    color="info"
                    block
                    large
                    v-if="!demoKayit"
                    outline
                    @click="checkSearch()"
                  >
                    <v-icon>search</v-icon>&nbsp;Demo Getir
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card>
    <v-flex v-if="!kayitvarmi">
      <v-layout align-center>
        <v-card class="ma-2">
          <v-card-title>
            <h1>
              <strong>{{ $t("Arkman-HotelRunner-Collaboration") }}</strong>
            </h1>
          </v-card-title>
          <v-flex class="pa-0">
            <v-layout row wrap>
              <v-flex xs12 sm6 md8>
                <img
                  height="400px"
                  width="600px"
                  src="../../../assets/images/hotelrunner.png"
                />
              </v-flex>
              <v-flex xs12 sm6 md4 class="ma-auto">
                <img width="300px" src="../../../assets/images/arkman.png" />
              </v-flex>
              <v-flex xs12 sm12 md12>
                <blockquote class="blockquote">
                  <ul>
                    <li>
                      {{ $t("runner-v1") }}
                    </li>
                    <li>
                      {{ $t("runner-v3") }}
                    </li>
                    <li>
                      {{ $t("runner-v5") }}
                    </li>
                    <li>
                      {{ $t("runner-v2") }}
                    </li>
                    <li>
                      {{ $t("runner-v4") }}
                    </li>
                    <li>
                      {{ $t("runner-v6") }}
                    </li>
                    <li>
                      {{ $t("runner-v7") }}
                    </li>
                  </ul>
                </blockquote>
                <blockquote class="blockquote">
                  {{ $t("runner-v8") }}
                  <v-btn
                    color="blue-grey"
                    class="white--text"
                    @click="irtibatDialog()"
                  >
                    {{ $t("CONTACT-US") }}
                    <v-icon right dark>contact_mail</v-icon>
                  </v-btn>
                </blockquote>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-layout>
    </v-flex>
    <v-flex xs12 v-if="kayitvarmi" sm12 pl-2 md12>
      <v-layout row wrap>
        <v-flex xs12 sm3 md3>
          <v-card flat>
            <v-card-actions>
              <v-layout row wrap class="project overdue">
                <v-flex xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                        <v-icon color="grey"> filter_list</v-icon
                        ><span class="subheading black--text">
                          {{ $t("Filters") }}
                        </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-list>
                    <v-card-title class="subtitle-1">
                      {{ $t("Price-Range") }}
                    </v-card-title>
                    <v-list-tile>
                      <v-flex xs12 sm4 md4>
                        <v-text-field
                          label="Min"
                          v-model="SearchInput.MinPrice"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4 md1> - </v-flex>
                      <v-flex xs12 sm4 md4>
                        <v-text-field
                          label="Max"
                          v-model="SearchInput.MaxPrice"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4 md2>
                        <v-btn
                          color="green"
                          outline
                          small
                          @click="OtelFiyatGetir(1)"
                        >
                          {{ $t("Apply") }}
                        </v-btn>
                      </v-flex>
                    </v-list-tile>

                    <v-card-title>
                      {{ $t("Child-Fee") }}
                    </v-card-title>
                    <v-list-tile>
                      <v-flex xs12 sm4 md12>
                        <v-checkbox
                          :label="$t('Child-Paid')"
                          value="0"
                          v-model="SearchInput.ChildAccept"
                        >
                        </v-checkbox>
                      </v-flex>
                    </v-list-tile>
                    <v-list-tile>
                      <v-flex xs12 sm4 md12>
                        <v-checkbox
                          :label="$t('Child-Free')"
                          value="1"
                          v-model="SearchInput.ChildAccept"
                        >
                        </v-checkbox>
                      </v-flex>
                    </v-list-tile>

                    <v-expansion-panel expand>
                      <v-expansion-panel-content>
                        <div slot="header">{{ $t("Hotel-Features") }}</div>
                        <v-card flat>
                          <v-card-text>
                            <v-list-tile
                              v-for="(item, index) in ozellikitems"
                              v-bind:key="index"
                            >
                              <v-checkbox
                                :label="item.FilterName"
                                :value="item.FilterId"
                                v-model="SearchInput.HotelPropertiesList"
                              ></v-checkbox>
                            </v-list-tile>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>

                      <v-expansion-panel-content>
                        <div slot="header">{{ $t("Hotel-Services") }}</div>
                        <v-card flat>
                          <v-card-text>
                            <v-list-tile
                              v-for="(item, index) in servisitems"
                              v-bind:key="index"
                            >
                              <v-checkbox
                                :label="item.FilterName"
                                :value="item.FilterId"
                                v-model="SearchInput.HotelServiceList"
                              ></v-checkbox>
                            </v-list-tile>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>

                      <v-expansion-panel-content>
                        <div slot="header">{{ $t("Room-Features") }}</div>
                        <v-card flat>
                          <v-card-text>
                            <v-list-tile
                              v-for="(item, index) in odaAditems"
                              v-bind:key="index"
                            >
                              <v-checkbox
                                :label="item.FilterName"
                                :value="item.FilterId"
                                v-model="SearchInput.RoomPropertiesList"
                              ></v-checkbox>
                            </v-list-tile>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <!--
                                        <v-list-group no-action sub-group value="true">
                                            <template v-slot:activator>
                                                <v-card-title class="headline">
                                                    {{ $t('Hotel-Features') }}
                                                </v-card-title>
                                            </template>
                                            <v-list-tile v-for="(item,index) in ozellikitems" v-bind:key="index">
                                                <v-checkbox :label="item.Aciklama" :value="item.Code"
                                                    v-model="otelozellik" @click="OtelOzellik(item.Code)" multiple>
                                                </v-checkbox>
                                            </v-list-tile>
                                        </v-list-group>

                                        <v-list-group no-action sub-group value="true">
                                            <template v-slot:activator>
                                                <v-card-title class="headline">
                                                     {{ $t('Hotel-Services') }} 
                                                </v-card-title>
                                            </template>
                                            <v-list-tile v-for="(item,index) in servisitems" v-bind:key="index">
                                                <v-checkbox :label="item.Aciklama" :value="item.Code"
                                                    @click="OtelServis(item.Code)" multiple></v-checkbox>
                                            </v-list-tile>
                                        </v-list-group>

                                        <v-list-group no-action sub-group value="true">
                                            <template v-slot:activator>
                                                <v-card-title class="headline">
                                                    {{ $t('Room-Features') }}
                                                </v-card-title>
                                            </template>
                                            <v-list-tile v-for="(item,index) in odaAditems" v-bind:key="index">
                                                <v-checkbox :label="item.Aciklama" :value="item.Code"
                                                    @click="OdaOzellik(item.Code)" multiple></v-checkbox>
                                            </v-list-tile>
                                        </v-list-group> -->
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs11 pl-3 sm9 md9>
          <v-layout row wrap v-show="kayitvarmi">
            <v-flex xs12 sm12 md12>
              <v-card>
                <v-list>
                  <v-list-tile>
                    <v-flex xs12 sm10 md10>
                      {{
                        $t("found-records-your-accommodation", {
                          value: SonucSayi,
                        })
                      }}
                    </v-flex>
                    <v-spacer></v-spacer>

                    <v-flex xs12 sm3 md3>
                      <v-select
                        hide-details=""
                        :items="siralamatipiitems"
                        @change="sortOtelResult()"
                        color="grey darken-1"
                        item-text="text"
                        v-model="SearchInput.SortType"
                        item-value="value"
                        :label="$t('Sort-By')"
                      >
                      </v-select>
                    </v-flex>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>

            <v-flex
              pb-1
              pt-1
              v-for="(item, index) in odaitems"
              v-bind:key="index"
              xs12
              sm12
              md12
            >
              <v-hover>
                <v-card
                  flat=""
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 1}`"
                  width="100%"
                >
                  <v-list>
                    <v-layout row wrap>
                      <v-flex xs12 sm3 md3>
                        <v-img
                          :src="item.HotelImageUrl"
                          height="245"
                          width="100%"
                        ></v-img>
                      </v-flex>
                      <v-flex xs12 sm9 md9>
                        <v-list-tile>
                          <span class="font-weight-black">
                            <h2>{{ item.HotelName }}</h2>
                          </span>
                        </v-list-tile>
                        <v-list-tile>
                          <span
                            class="font-weight-medium"
                            style="padding-top: 20px"
                          >
                            <v-icon color="primary">gps_fixed</v-icon>
                            {{ item.CityName }},{{ item.CountryName }}
                            <!--Harita' alanı eklenebilir - <a href="#">Haritada Göster</a>-->
                          </span>
                        </v-list-tile>
                        <v-list-tile>
                          <span class="font-weight-medium">
                            <v-icon color="primary">location_on</v-icon>
                            {{ item.Address }}
                          </span>
                          <v-spacer></v-spacer>
                          <span class="font-weight-light caption">
                            {{ item.NightCount }} {{ $t("Night-Total-Amount") }}
                          </span>
                        </v-list-tile>
                        <v-list-tile>
                          <span class="font-weight-black">
                            <v-icon color="primary">alarm</v-icon>
                            {{ item.CheckInTime | dateformat }}
                            {{ item.CheckInTime | gettime }} -
                            {{ item.CheckOutTime | dateformat }}
                            {{ item.CheckOutTime | gettime }}
                          </span>
                          <v-spacer></v-spacer>
                          <span class="font-weight-black mr-1">
                            <h2>
                              {{ item.ArkmanPrice | moneyformat }}
                              {{ item.CurrencyType }}
                            </h2>
                          </span>
                        </v-list-tile>
                        <v-list-tile>
                          <span class="font-weight-black mr-1">
                            <v-icon color="primary">meeting_room</v-icon>
                            {{ item.RateName }}
                          </span>
                          <v-spacer></v-spacer>
                          <v-btn @click="idgonder(item.RateId)" color="green">
                            <span class="subtitle-1 white--text">
                              {{ $t("Select") }}
                            </span>
                          </v-btn>
                        </v-list-tile>
                      </v-flex>
                    </v-layout>
                  </v-list>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <hotelloadingcomp
      ref="hotelloadingcomp"
      iconname="local_hotel"
      v-bind:mesaj="$t('Your-hotels-are-being-prepared')"
      v-model="loadingdialog"
    >
    </hotelloadingcomp>

    <template v-if="vmodelpagination">
      <div class="text-xs-center">
        <v-container>
          <v-layout justify-center>
            <v-flex xs8>
              <v-pagination
                :disabled="paginationDisabled"
                color="info"
                v-model="sayfalama"
                :length="pagenumber"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>

    <v-dialog v-model="satisDialog" width="500">
      <v-card>
        <v-card-title class="headline warning lighten-2" primary-title>
          {{ $t("Warning") }}
        </v-card-title>

        <v-card-text>
          <blockquote class="blockquote">
            {{ $t("runner-v9") }}
          </blockquote>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="satisDialogTamam()">
            {{ $t("OK") }}
          </v-btn>
          <v-btn color="error" flat @click="satisDialog = false">
            {{ $t("Cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="timeout"
      :top="y === 'top'"
      :bottom="y === 'bottom'"
      :right="x === 'right'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      {{ text1 }}
      <v-btn flat color="pink" @click.native="snackbar = false">{{
        $t("Close")
      }}</v-btn>
    </v-snackbar>
    <!--

    Google haritalar açılırsa dialog box'a eklenecek

        <GmapMap v-bind:center="center" :zoom="7" map-type-id="roadmap" style="width: 500px; height: 300px">
       <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :draggable="true" @click="center=m.position" />
        </GmapMap> -->
  </div>
</template>

<script>
import auth from "@/api/auth.js";
import _ from "underscore";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import hotelloadingcomp from "@/components/app/customcomp/hotelloadingcomp.vue";
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue";
import parainput from "@/components/app/customcomp/parainput.vue";
import tanitimMail from "@/components/app/customcomp/tanitimMail.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

//import VueGoogleMaps from "vue2-google-maps"

export default {
  data() {
    return {
      selectedChild1:null,
      selectedChild2:null,
      selectedChild3:null,
      selectedChild4:null,
      selectedChild5:null,
      selectedChild6:null,
      selectedChild7:null,
      selectedChild8:null,
      selectedChild9:null,
      selectedChild10:null,
      cocukSayiItems: [
        {
          text: "1 yaş ve altı",
          value: 1,
        },
        {
          text: "2",
          value: 2,
        },
        {
          text: "3",
          value: 3,
        },
        {
          text: "4",
          value: 4,
        },
        {
          text: "5",
          value: 5,
        },
        {
          text: "6",
          value: 6,
        },
        {
          text: "7",
          value: 7,
        },
        {
          text: "8",
          value: 8,
        },
        {
          text: "9",
          value: 9,
        },
        {
          text: "10",
          value: 10,
        },
        {
          text: "11",
          value: 11,
        },
        {
          text: "12",
          value: 12,
        },
        {
          text: "13",
          value: 13,
        },
        {
          text: "14",
          value: 14,
        },
        {
          text: "15",
          value: 15,
        },
        {
          text: "16",
          value: 16,
        },
        {
          text: "17",
          value: 17,
        },
        {
          text: "18",
          value: 18,
        },
      ],
      yetkidialog: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      //maps için ayarlar
      center: {
        lat: 62,
        lng: 10.0,
      },
      markers: [
        {
          position: {
            lat: 10.0,
            lng: 10.0,
          },
        },
        {
          position: {
            lat: 11.0,
            lng: 11.0,
          },
        },
      ],
      // maps için ayarlar bitti
      mailDialog: {
        AdSoyad: null,
        Email: null,
        SirketAdi: null,
        GSM: null,
        Adres: null,
        Mesaj: null,
      },
      tanitimValid: true,
      tanitimDialog: false,
      satisControl: false,
      satisDialog: false,
      rules: {
        required: (value) => !!value || this.$t("Mandatory-Areas"),
      },
      length: 3,
      window: 0,
      aramaYapildimi: false,
      pagenumber: 1,
      sayfalama: 1,
      paginationDisabled: false,
      vmodelpagination: false,
      islemTipi: null,
      loadingdialog: false,
      validform: true,
      progress: true,
      search: "",
      cocukAzalt: false,
      Azalt: false,
      cocukSayi: 0,
      yetiskinSayi: 1,
      odaSayi: 0,
      menu: false,
      OtelAdTitle: false,
      odaitems: [],
      secilenkayitlar: [],
      otelitems: [],
      ozellikitems: [],
      servisitems: [],
      oteladitems: [],
      otelozellikitems: [],
      otelservisitems: [],
      odaAditems: [],
      odaOzellikAdiitems: [],
      otelozellik: [],
      OtelText: null,
      OtelValue: null,
      SonucSayi: 0,
      SearchInput: {
        LocationKey: null,
        LocationName: null,
        StartDate: null,
        EndDate: null,
        Adt: 0,
        MarkupType: 0,
        MarkupPrice: 0,
        MinPrice: 0,
        MaxPrice: 0,
        Language: null,
        SortType: "Price",
        ChildAccept: 2,
        CurrencyType: null,
        HotelPropertiesList: [],
        HotelServiceList: [],
        RoomPropertiesList: [],
        childAgeList:[]
      },
      markupitems: [
        {
          text: this.$t("Amount"),
          value: 0,
        },
        {
          text: this.$t("Percentage"),
          value: 1,
        },
      ],
      siralamatipiitems: [
        {
          text: this.$t("Price-Ascending"),
          value: "Price",
        },
        {
          text: this.$t("Price-Descending"),
          value: "PriceDesc",
        },
      ],
      kayitsayisi: [
        {
          text: "50",
          value: 50,
        },
        {
          text: "100",
          value: 100,
        },
      ],
      OtelAdOzel: "",
      searchText: "",
      kayitvarmi: false,
      isOnboarding:false,
      demoKayit: false,
      kayitsayi: 0,
      clipped: true,
      drawer: true,
      fixed: false,
      right: true,
      dialog: false,
      loginstatus: true,
      text1: "",
      snackbar: false,
      loading: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      unvan: null,
      confirm: null,
      Credential: {
        email: "",
        password: "",
      },
      childAgeList:[],
      valid: true,
    };
  },
  props: {
    source: String,
  },
  methods: {
    getReadyChildAgeList(age,index){
      var addParams = {
        Age: age,
        ChildCount: index
      };

      var controlValue = this.childAgeList.find(x=> x.ChildCount == index);
      if(controlValue != undefined){
        this.childAgeList.splice(controlValue,1);
        this.childAgeList.push(addParams);
      }else{
        this.childAgeList.push(addParams);
      }

    },
    sortOtelResult() {
      this.odaitems = this.odaitems.reverse();
    },
    checkSearch() {
      if (this.$refs.OtelFiyatGetir.validate()) {
        //Kullanıcının HotelRunner Üyeliği Var Mı ?
        if (this.demoKayit) {
          this.OtelFiyatGetir(1);
        } else {
          this.satisDialog = true;
        }
      }
    },
    irtibatDialog() {
      this.$refs.tanitimdialog.open(0);
    },
    satisDialogTamam() {
      this.satisDialog = false;
      this.OtelFiyatGetir(1);
    },
    aramakontrol() {
      this.aramaYapildimi = true;
    },
    getparabirimi() {
      return helpers.getparabirimi();
    },
    idgonder(RateID) {
      if (this.demoKayit == false) {
        this.SearchInput.StartDate = "2022-09-29";
        this.SearchInput.EndDate = "2022-09-30";
      }

      var url =
        "#/hotelrunner/otelislem/id?" +
        "rateid=" +
        RateID +
        "&basTarih=" +
        this.SearchInput.StartDate +
        "&bitTarih=" +
        this.SearchInput.EndDate +
        "&KisiSayi=" +
        this.yetiskinSayi +
        "&Min=" +
        this.SearchInput.MinPrice +
        "&Max=" +
        this.SearchInput.MaxPrice +
        "&CocukKabul=" +
        this.SearchInput.ChildAccept +
        "&Siralama=" +
        this.SearchInput.SortType +
        "&MarkupTip=" +
        this.SearchInput.MarkupType +
        "&MarkupDeger=" +
        this.SearchInput.MarkupPrice +
        "&islemTip=" +
        this.islemTipi;

      window.open(url, "_target");
    },
    cocukArttir() {
      this.cocukAzalt = false;
      this.cocukSayi++;
    },
    cocukAz() {
      if (this.cocukSayi >= 1) {
        this.cocukSayi--;
        this.childAgeList.splice(this.childAgeList.length-1,1);
      } else {
        this.cocukAzalt = true;
      }
    },
    yetiskinArttir() {
      this.Azalt = false;
      this.yetiskinSayi++;
    },
    yetiskinAzalt() {
      if (this.yetiskinSayi >= 2) {
        this.yetiskinSayi--;
      } else {
        this.Azalt = true;
      }
    },
    getAccountDetails() {
      this.loadingvmodel = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CustomerID: credentials.MusteriID,
        ServiceID: 2,
      };

      this.$http
        .post(auth.API_URL + "api/Booking/ServiceInfoLoad", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            auth.HOTELRUNNERUSERNAME = response.body.UserName;
            auth.HOTELRUNNERUSERPASS = response.body.Password;
            this.demoKayit = response.body.Active;
            this.isOnboarding = response.body.IsOnboarding;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    startDateChange(startDate) {
      var date = startDate.split("-");
      var changeDate = new Date(date[0], date[1] - 1, date[2]);
      changeDate.setDate(changeDate.getDate() + 1);
      var day;
      var month;
      var year = changeDate.getFullYear();
      if (10 > changeDate.getDate()) {
        day = "0" + changeDate.getDate();
      } else {
        day = changeDate.getDate();
      }
      if (9 > changeDate.getMonth()) {
        month = "0" + (changeDate.getMonth() + 1);
      } else {
        month = changeDate.getMonth() + 1;
      }
      return year + "-" + month + "-" + day;
    },
    OtelCek: OtelCek,
    OtelFiyatGetir: OtelFiyatGetir,
  },
  components: {
    tarihim,
    hotelloadingcomp,
    yuzdeinput,
    parainput,
    yetkidialog,
    tanitimMail,
  },
  watch: {
    "SearchInput.MarkupType": function (val) {
      this.SearchInput.MarkupPrice = 0;
    },
    search(val) {
      if (this.aramaYapildimi == false) {
        val && this.OtelCek(val);
      } else {
        this.aramaYapildimi = false;
      }
    },
    "SearchInput.HotelPropertiesList": function (val) {
      if (val != []) {
        this.OtelFiyatGetir(1);
      }
    },
    "SearchInput.HotelServiceList": function (val) {
      if (val != []) {
        this.OtelFiyatGetir(1);
      }
    },
    "SearchInput.RoomPropertiesList": function (val) {
      if (val != []) {
        this.OtelFiyatGetir(1);
      }
    },
    "SearchInput.ChildAccept": function (val) {
      this.OtelFiyatGetir(1);
    },
    "SearchInput.StartDate": function (val) {
      this.SearchInput.EndDate = this.startDateChange(val);
    },
    sayfalama(value) {
      this.OtelFiyatGetir(value);
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    timeformat: function (c) {
      return helpers.timeformat(c);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    gettime: function (t) {
      return helpers.getTime(t);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
      //YETKİ OK
      this.getAccountDetails();
      this.islemTipi = "hryeni";
      if (
        this.$route.params.id != undefined &&
        this.$route.params.id == "isl=hryeni"
      ) {
        this.islemTipi = "hryeni";
      } else {
        if (this.$route.query.isl == "hrget") {
          this.islemTipi = "hrget";
        } else {
          this.islemTipi = "hryeni";
        }
      }

      this.Azalt = true;
      //Bitiş tarihi 1 gün arttılıyor >>>>>
      var today = new Date();
      var dd = today.getDate() + 1;
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      today = yyyy + "-" + mm + "-" + dd;
      this.SearchInput.EndDate = today;
      // Bitits Tarihi arttırılma bitti <<<<<

      //Çekilecek filtreler dil'e göre filtreleniyor.

      var params = {
        Language: "tr",
      };

      //HRFacilityTypes -- Otel Ozellikleri Çekiliyor.

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/OtelProperties", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.ozellikitems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );

      //HRServiceTypes -- Otel Servisleri Çekiliyor.
      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/OtelServices", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.servisitems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );

      //HRSalesRoomPropertyTypes -- Oda Özellikleri Çekiliyor.
      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/RoomProperties", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.odaAditems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};

function OtelFiyatGetir(pagenumber) {

  if (this.$refs.OtelFiyatGetir.validate()) {
    //Kullanıcının HotelRunner Üyeliği Var Mı ?

    // Hotel Runner Anlaşması var Direk devam
    this.odaitems = null;
    //Tarih Kontrolleri

    var BasTarih = new Date(this.SearchInput.StartDate);
    var BitisTarih = new Date(this.SearchInput.EndDate);
    var Bugun = new Date(helpers.getDateNow());

    //Bugunun Tarihi Baslangic Tarihi ile kıyaslamak için

    if (BasTarih >= Bugun && BitisTarih > BasTarih) {
      //Tarihler kontrol edildi

      this.loadingdialog = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        LogInput: {
          UserID: credentials.UserID,
          CustomerID: credentials.MusteriID,
        },
        LocationName: null,
        LocationKey: this.SearchInput.LocationKey,
        MarkupType: this.SearchInput.MarkupType,
        MarkupPrice: this.SearchInput.MarkupPrice,
        Language: "tr",
        StartDate: this.SearchInput.StartDate,
        EndDate: this.SearchInput.EndDate,
        Adt: this.yetiskinSayi,
        ChildAgeList: this.childAgeList,
        SortType: this.SearchInput.SortType,
        MinPrice: parseInt(this.SearchInput.MinPrice),
        MaxPrice: parseInt(this.SearchInput.MaxPrice),
        ChildAccept: this.SearchInput.ChildAccept,
        HotelPropertiesList: this.SearchInput.HotelPropertiesList,
        HotelServiceList: this.SearchInput.HotelServiceList,
        RoomPropertiesList: this.SearchInput.RoomPropertiesList,
        CurrencyType: credentials.ParaBirimi,
        Paging: {
          PageNumber: pagenumber,
          DataCount: 20,
        },
      };
      window.localStorage.setItem("suggestedParams", JSON.stringify(params));

      //Kullanıcı HotelRunner anlaşması yok ise Dummy data için location manipule ediliyor.
      if (this.demoKayit == false) {
        params.LocationKey = "149";
        params.Adt = 2;
        params.CurrencyType = "TRY";
        params.StartDate = "2022-09-29";
        params.EndDate = "2022-09-30";
        // StartDate: this.SearchInput.StartDate,
        // EndDate: this.SearchInput.EndDate,
      }

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/Search", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.loadingdialog = false;

            this.odaitems = response.body;
            this.kayitvarmi = true;

            this.odaSayi = this.odaitems.length;

            //Kayıt Sayısı sayfalamadan geliyor
            this.aramaYapildimi = false;
            if (response.body.length > 0) {
              this.SonucSayi = response.body[0].TotalCount;
              //this.OtelAdTitle = true
              if (response.body[0].TotalCount > 20) {
                this.vmodelpagination = true;
                this.pagenumber = response.body[0].TotalPage;
              }
            } else {
              this.SonucSayi = 0;
            }
          },
          (response) => {
            this.loadingdialog = false;

            if (response.status === 0) {
              this.text1 = "Service Unavailable-FiyatList";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-FiyatList";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    } else {
      this.text1 = "Hatalı Tarih Girişi";
      this.snackbar = true;
    }
  } else {
    this.text1 = "Lütfen zorunlu alanları doldurunuz. ";
    this.snackbar = true;
  }
}

function OtelCek(val) {
  var params = {
    Key: decodeURIComponent(val),
    Location: "tr", // Ekleme
  };
  if (val.length >= 3) {
    setTimeout(() => {
      this.oteladitems = [];
      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/SearchLocation", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.otelitems = response.body;
            //İlce,Otel,Sehir ve Ülke  (Şehir ve Ülke Yedekleri) ayrı ayrı listeler tek listeye alınıyor
            //Arama Listeleri backend tarafında birleştirildi tek list olarak dönüyor
            //Arama Listesi birleşmesinden dolayı Diff değeri ile iconlar ayırt edilecek

            for (var i = 0; i < this.otelitems.length; i++) {
              this.oteladitems.push({
                name: this.otelitems[i].name,
                value: this.otelitems[i].locationId,
                deger: this.otelitems[i].hotelLocationType,
              });
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OtelAdresList";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-OtelAdresList";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    }, 500);
  }
}
</script>
